/**
 * 提现类型枚举
 */
export enum WithdrawalType {
  /** 法币提现 */
  Cash = 1,
  /** 数字货币提现 */
  DigitalCurrency = 2,
}

